module.exports = __webpack_public_path__ + "static/media/not-come.1eede2da.svg";